module.exports = __webpack_public_path__ + "img/gou (2).a86e3d3d.svg";